import React, { Component } from 'react';
import $ from 'jquery';
import axios from 'axios';
import typing from '../../../static/image/v2/review/Typing.png';
import lock from '../../../static/image/v2/review/Lock.png';
import {openPopup} from "../../../utils/CommonUtils";
import { ORDER_API } from 'constants/apiUrls';
import goodImage from "../../../static/image/v2/review/good.png";
import badImage from "../../../static/image/v2/review/bad.png";
import photoImage from "../../../static/image/v2/review/photo.png";

class ReviewCardV2 extends Component {
  constructor(props) {
    super(props)

    var reviewInfo = this.props.review

    this.state = {
      reviewInfo: reviewInfo
    }
  }

  componentDidUpdate(prevProps) {
    // props가 변경되었는지 확인
    if (prevProps.review !== this.props.review) {
      this.setState({
        reviewInfo: this.props.review // props가 변경되면 state 업데이트
      });
    }
  }

  render() {
    let state = this.state
    let reviewInfo = state.reviewInfo
    let underReview = reviewInfo.shopReply


    // 메뉴 리스트
    let reviewItemList = reviewInfo.menuList.map((value, index) => {
      let bold = ''
      let comma = ', '
      let menuName = value.menuName
      if(value.recommended) {
        bold = 'bold'
        menuName = `${value.menuName}(추천)`
      }
      if(index === reviewInfo.menuList.length - 1) {
        comma = ''
      }

      return (
        <span className={ bold } key={ index }>{ menuName }{ comma }</span>
      )
    })
    
    // 공개여부 설정
    let topText = '공개리뷰'
    let topImg = typing

    if(reviewInfo.nondisplaySta === 1) {
      topText = '숨긴리뷰'
      topImg = lock
    }
    
    // 리뷰 이미지 불러오기
    let reviewImgList = reviewInfo.imageFileList.map((value, index) => {
      return (
        <div className='imgBox' key={ index }>
          <img className="reviewImg" src={ value.path } alt="리뷰 이미지" />
          <button className="photoBtn" onClick={() => photoEvent(value.path)}>
            <img src={photoImage} alt="확대" />
          </button>
        </div>  
      )
    })

    const photoEvent = (image) => {
      const reviewPopupImage = document.getElementById("reviewPopupImage");
      reviewPopupImage.setAttribute("src", image);
      openPopup("reviewPopup");
    }

    let reviewTextBox = 'reviewTextBox'
    let newReviewBox = 'newReviewBox'
    let modiReviewBox = 'modiReviewBox'

    if(reviewInfo.imageFileList.length === 0) {
      reviewTextBox = 'reviewTextBox reviewTextBox2'
    }

    // 답변 불러오기
    let modiText = ''
    let underReviewId = 0

    if(underReview) {
      modiText = underReview.content
      newReviewBox = 'newReviewBox hide'
      underReviewId = underReview.id || 0;
    } else {
      modiReviewBox = 'modiReviewBox hide'
    }

    const addEvent = async (e) => {
      const target = e.target;
      const order = target.getAttribute("data-order");
      const shopId = document.querySelector(".shopSelectText").getAttribute("data-id");
      const topId = target.getAttribute("data-top");
      const visible = target.getAttribute("data-visible");
      const content = document.querySelector(`.newReview${order}`).value;
      let hide = visible === "true";

      await axios.post(`${ORDER_API}/review`, {
        channelType: 2,
        shopId: Number(shopId),
        orderId: String(order),
        writerId: Number(shopId),
        writerType: 1,
        content: String(content),
        type: 2,
        isVisible: hide,
        upperReviewId: Number(topId),
      });

      window.location.reload();
    }

    const setEvent = async (e) => {
      const target = e.target;
      const reviewId = target.getAttribute("data-id");
      const order = target.getAttribute("data-order");
      const content = document.querySelector(`.modiReview${order}`).value;

      await axios.put(`${ORDER_API}/review/${reviewId}`, {
        content: content
      });

      window.location.reload();
    }

    const deleteEvent = async (id) => {
      await axios.delete(`${ORDER_API}/review/${id}`);

      window.location.reload();
    }

    // 답변 수정
    /*$('.modiBtn').off('click').on('click', function() {
      var reviewId = $(this).attr('data-id');
      var newOrder = $(this).attr('data-order');
      var content = $(`.modiReview${ newOrder }`).val();

      axios.put(`${ ORDER_API }/review/${ reviewId }`, {
        content: content,
        newImageList: [],
        removedImageIdList: [],
        changedMenuList: []
      }).then(function() {
        window.location.reload()
      })
    })
*/
    // 답변 등록
    /*$('.newBtn').off('click').on('click', function() {
      var newOrder = $(this).attr('data-order');
      var shopId = $('.shopSelectText').attr('data-id');
      var newTopId = $(this).attr('data-top');
      var visible = $(this).attr('data-visible');
      var content = $(`.newReview${ newOrder }`).val();

      var hide = true
      if(Number(visible) === 1) {
        hide = false
      }

      axios.post(`${ ORDER_API }/review`, {
        channelType: 2,
        shopId: Number(shopId),
        orderId: String(newOrder),
        writerId: Number(shopId),
        writerType: 1,
        content: String(content),
        type: 2,
        isVisible: hide,
        upperReviewId: Number(newTopId),
      }).then(function() {
        window.location.reload()
      })
    })*/
    // 답변 수정
    /*$('.modiBtn').off('click').on('click', function() {
      var reviewId = $(this).attr('data-id');
      var newOrder = $(this).attr('data-order');
      var content = $(`.modiReview${ newOrder }`).val();

      axios.put(`${ ORDER_API }/review/${ reviewId }`, {
        content: content,
        newImageList: [],
        removedImageIdList: [],
        changedMenuList: []
      }).then(function() {
        window.location.reload()
      })
    })*/
    // 답변 삭제
    /*$('.removeBtn').off('click').on('click', function() {
      var result = window.confirm('삭제하시겠습니까?')
      var reviewId = $(this).attr('data-id');

      if(result) {
        axios.delete(`${ ORDER_API }/review/${ reviewId }`).then(function() {
          window.location.reload()
        })
      }
    })*/

    return (
      <div className={`reviewCard reviewCard${reviewInfo.id}`}>
        <div className='reviewBox1'>
          <div className='reviewBox1Top'>
            <span>{ reviewInfo.createDateTime }</span>
            <div className='reviewBox1TopIcon'>
              <img src={ topImg } alt="" />
              { topText }
            </div>
          </div>
          
          <h3>{ reviewInfo.writerName }</h3>
          <div className={`starBox starBox${ reviewInfo.id }`}>
            <img src={reviewInfo.evaluationType === 1 ? goodImage : badImage} alt=""/>
          </div>
          <div className='reviewItemListBox'>
            { reviewItemList }
          </div>
        </div>
        <div className='reviewBox2'>
          <div className='reviewImgBox'>
            { reviewImgList }
          </div>
          <textarea className={`${ reviewTextBox }`} defaultValue={ reviewInfo.content } readOnly />
        </div>
        <div className='reviewBox3'>
          <div className={`${ newReviewBox }`}>
            <textarea className={`newReview newReview${ reviewInfo.orderId }`} placeholder='답변 입력 (100자 이내)' maxLength={100} />
            <div className='btnListBox'>
              <button className='commonBtn blueBtn width90 newBtn'
                onClick={(e) => addEvent(e)}
                data-id={ underReviewId }
                data-order={ reviewInfo.orderId }
                data-top={ reviewInfo.id }
                data-visible={ reviewInfo.nondisplaySta }
              >등록</button>
            </div>
          </div>
          <div className={`${ modiReviewBox }`}>
            <textarea className={`modiReview modiReview${ reviewInfo.orderId }`} defaultValue={ modiText } maxLength={100} />
            <div className='btnListBox'>
              <button className='commonBtn width90 removeBtn' data-id={ underReviewId } onClick={() => deleteEvent(underReviewId)}>삭제</button>
              <button className='commonBtn width90 marginLeft5 modiBtn' onClick={(e) => setEvent(e)} data-id={ underReviewId } data-order={ reviewInfo.orderId }>수정</button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export { ReviewCardV2 }